import { CarTesian } from "assets/icons";
import { InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import CartesianPlane from "./CartesianPlane";
import { CartesianPlaneSetting } from "./CartesianPlaneSetting";

export const CartesianPlaneWidget: WidgetType = {
  name: "Cartesian Plane",
  component: CartesianPlane,
  icon: CarTesian,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 245,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.75,
  },
  defaultState: {
    grid: {
      point: [],
      line: [],
      range: {
        leftRange: -10,
        rightRange: 10,
        bottomRange: -10,
        topRange: 10,
        xStep: 1,
        yStep: 1,
        xValue: 0,
        yValue: 0,
        gridSpacingX: 40,
        gridSpacingY: 25,
      },
      disableDrag: false,
      pointIndex: null,
      lineIndex: null,
      type: null,
    },
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 50,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Draw points and lines in the coordinate plane using the control buttons.",
      },
    },
    grid: {
      defaultValue: {
        point: [],
        line: [],
        range: {
          leftRange: -10,
          rightRange: 10,
          bottomRange: -10,
          topRange: 10,
          xStep: 1,
          yStep: 1,
          xValue: 0,
          yValue: 0,
          gridSpacingX: 40,
          gridSpacingY: 25,
        },
        disableDrag: false,
        pointIndex: null,
        lineIndex: null,
        type: null,
        gridSize: 10,
      },
      editor: CartesianPlaneSetting,
      info: {
        label: "Actions",
        options: [
          { label: "Add Point", type: "point" },
          { label: "Add line", type: "line" },
        ],
        graph: {
          label: "Graph options",
          switchLabel: "Disable dragging",
        },
        point: {
          label: "Point options",
        },
        removeButtonLabel: "Remove",
        resetButtonLabel: "Reset",
      },
    },
  },
  quickActions: {},
};
